<template>
  <vue-cookie-accept-decline
    :ref="'myPanel1'"
    :elementId="'myPanel1'"
    :debug="false"
    :position="'bottom-left'"
    :type="'floating'"
    :disableDecline="false"
    :transitionName="'slideFromBottom'"
    @status="cookieStatus"
    @clickedAccept="cookieClickedAccept"
    @clickedDecline="cookieClickedDecline"
    @removedCookie="cookieRemovedCookie">

    <!-- Optional -->
    <div slot="message">
      {{ "lng_cookies_desc_text" | translate }}
      <a href="https://cookiesandyou.com/" target="_blank">Learn More...</a>
    </div>

    <!-- Optional -->
    <div slot="declineContent">
    Decline</div>

    <!-- Optional -->
    <div slot="acceptContent">
    Accept</div>
    
  </vue-cookie-accept-decline>
</template>

<script>
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

export default {
  name: "HandleCookies",
  components: {
    VueCookieAcceptDecline
  },
  data () {
    return {
        status: null
    }
  },
  methods: {
    cookieStatus (status) {
      console.log('status: ' + status)
      this.status = status
    },
    cookieClickedAccept () {
      console.log('here in accept')
      this.status = 'accept'
    },
    cookieClickedDecline () {
      console.log('here in decline')
      this.status = 'decline'
    },
    cookieRemovedCookie () {
      console.log('here in cookieRemoved')
      this.status = null
      this.$refs.myPanel1.init()
    },

    removeCookie () {
      console.log('Cookie removed')
      this.$refs.myPanel1.removeCookie()
    }
  },
  computed: {
      statusText () {
        return this.status || 'No cookie set'
      }
  }
};
</script>
